export const ETHIcon = () => {
    return (
        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="#627EEA" />
            <path d="M30.4575 11.0781V25.0649L42.4523 30.3474L30.4575 11.0781Z" fill="white" fillOpacity="0.602" />
            <path d="M30.4578 11.0781L18.4614 30.3474L30.4578 25.0649V11.0781Z" fill="white" />
            <path d="M30.4575 39.4113V48.9151L42.4603 32.5488L30.4575 39.4113Z" fill="white" fillOpacity="0.602" />
            <path d="M30.4578 48.9151V39.4098L18.4614 32.5488L30.4578 48.9151Z" fill="white" />
            <path d="M30.4575 37.2157L42.4523 30.3516L30.4575 25.0723V37.2157Z" fill="white" fillOpacity="0.2" />
            <path d="M18.4614 30.3516L30.4578 37.2157V25.0723L18.4614 30.3516Z" fill="white" fillOpacity="0.602" />
        </svg>

    );
}